/**
 * Shared currency formatter for service charge surfaces.
 *
 * IDR uses the `id-ID` locale so browsers render `Rp` instead of falling
 * back to `US$` (a known Chrome behavior when IDR is requested under
 * en-US with the default `symbol` display).
 *
 * All service charge views render whole units (0 decimals) per product
 * decision.
 */
export function formatCurrencyAmount(amount: number, currencyCode?: string | null): string {
  const code = (currencyCode || 'IDR').toUpperCase();
  try {
    const locale = code === 'IDR' ? 'id-ID' : undefined;
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: code,
      currencyDisplay: 'symbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  } catch {
    return `${code} ${Math.round(amount).toLocaleString()}`;
  }
}